module.exports = __webpack_public_path__ + "static/media/guide.2bf5e119.png";